import { Direction, Displaying, Spacing } from "@bonusx-global/bx-design-system";
import { type SxProps } from "@mui/system";

export function getDrawerContentStylesByDevice(isMobile: boolean): SxProps {
  let styles: SxProps = {
    display: Displaying.flex,
    flexDirection: Direction.column,
    gap: Spacing[1500],
  };

  if (isMobile) {
    return {
      ...styles,
      paddingTop: Spacing[1500],
      paddingRight: Spacing[1000],
      paddingBottom: Spacing[4000],
      paddingLeft: Spacing[1000],
    };
  }

  return {
    ...styles,
    paddingTop: Spacing[2500],
    paddingBottom: Spacing[2500],
    paddingLeft: Spacing[1500],
    paddingRight: Spacing[1500],
  };
}
